'use strict';

var assign = require('./util/assign');

var fs = {}; // Export graceful-fs:

assign(fs, require('./fs')); // Export extra methods:

assign(fs, require('./copy'));
assign(fs, require('./copy-sync'));
assign(fs, require('./mkdirs'));
assign(fs, require('./remove'));
assign(fs, require('./json'));
assign(fs, require('./move'));
assign(fs, require('./move-sync'));
assign(fs, require('./empty'));
assign(fs, require('./ensure'));
assign(fs, require('./output'));
assign(fs, require('./path-exists'));
module.exports = fs;